import React, { useState } from 'react';
import './CommonStyles.css';
import './AddSellStyles.css';
import './ProductSearchStyles.css';
import dateUtils from '../../utils/dateUtils';


const today = () => dateUtils.getChicagoISOString().split('T')[0];

const CATEGORIES = [
  'All Lotto', 'BEER-41', 'BOURBON-20', 'BOURBONS', 'BRANDY-2', 'CANADIAN-35',
  'CANDY (SUGAR)', 'CANNABIS-83', 'CIGARETTES-5', 'CIGARS-4', 'COGNAC-44',
  'CORDIALS & LIQUEURS-48', 'CRAFT beer 8.5%', 'CRAFT BEER-43', 'CREME DE CACAO-60',
  'DRINKS-51', 'GIN-51', 'GROCERY-73', 'IMPORTED WINE-3', 'IRISH WHISKEY-22',
  'JUICE, WATER, NON-SUGAR, POWDERED MIXES-93', 'LIQUEUR-11', 'LIQUEURES & CORDIALS-33',
  'LIQUOR-23', 'Lotto Payout-106', 'Lotto Sale-105', 'Lotto-109', 'MALT BASED COOLERS-47',
  'MINIATURES-28', 'MISC', 'MIXERS-8', 'Online Lottery', 'Online Payout',
  'PHILLIPS & KING-98', 'PREMIUM SPIRITS-103', 'PREMIXED DRINKS-26', 'RTD COCKTAILS-42',
  'RUM-34', 'SCHNAPPS-17', 'SCOTCH-29', 'SINGLE BEER-30', 'SNACKS-69',
  'SNACKS, FOOD, SPICES-94', 'SPARKLING WINE-37', 'SPIRITS CENTRAL-75',
  'SPIRITS GLAZERS-76', 'SPIRITS MOON-81', 'SPIRITS-91', 'STRAIGHT BOURBON-59',
  'STRAIGHT RYE-62', 'SUGAR DRINKS-95', 'TEQUILA-12', 'TOBACCO-53', 'US WINE-6',
  'VERMOUTH-49', 'VODKA-46', 'WHISKEY', 'WHISKY-70', 'WINE CENTRAL-99',
  'WINE MOON-80', 'WINE-36',
];

const AddPurchaseRequisition = ({ onBack }) => {
  const [form, setForm] = useState({
    brand: '',
    category: '',
    businessLocation: '',
    referenceNo: '',
    requiredByDate: today(),
    products: [],
  });
  const [errors, setErrors] = useState({});
  const [productSearchTerm, setProductSearchTerm] = useState('');

  const handleChange = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const addProductRow = () => {
    if (!productSearchTerm.trim()) return;
    setForm(prev => ({
      ...prev,
      products: [...prev.products, {
        id: Date.now(),
        name: productSearchTerm.trim(),
        alertQuantity: 0,
        requiredQuantity: 1,
      }],
    }));
    setProductSearchTerm('');
  };

  const updateProduct = (id, key, value) => {
    setForm(prev => ({
      ...prev,
      products: prev.products.map(p => p.id !== id ? p : { ...p, [key]: value }),
    }));
  };

  const removeProduct = (id) => setForm(prev => ({ ...prev, products: prev.products.filter(p => p.id !== id) }));

  const handleSave = () => {
    const newErrors = {};
    if (!form.businessLocation) newErrors.businessLocation = 'Business location is required';
    if (!form.requiredByDate) newErrors.requiredByDate = 'Required by date is required';
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    alert('Save Purchase Requisition – API integration pending');
    if (onBack) onBack();
  };

  return (
    <div className="sell-form-container add-sell-override">
      <div className="page-header">
        <button
          type="button"
          onClick={onBack}
          style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '0.5rem 0.75rem', cursor: 'pointer', fontSize: '1.2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '40px', height: '40px' }}
          title="Back to Purchases"
        >←</button>
        <h2 style={{ fontSize: '1.25rem' }}>Add Purchase Requisition</h2>
      </div>

      <form className="sell-form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <div className="form-section-content">
          <div className="form-row">
            <div className="form-group">
              <label>Brand:</label>
              <input
                type="text"
                className="form-input"
                placeholder="e.g. PLB 2025"
                value={form.brand}
                onChange={(e) => handleChange('brand', e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Category:</label>
              <select
                className="form-select"
                value={form.category}
                onChange={(e) => handleChange('category', e.target.value)}
              >
                <option value="">Please Select</option>
                {CATEGORIES.map(cat => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Business Location:</label>
              <select
                className={`form-select ${errors.businessLocation ? 'error' : ''}`}
                value={form.businessLocation}
                onChange={(e) => handleChange('businessLocation', e.target.value)}
              >
                <option value="">Please Select</option>
                <option value="1">Main Location</option>
              </select>
              {errors.businessLocation && <span className="error-text">{errors.businessLocation}</span>}
            </div>

            <div className="form-group">
              <label>Reference No:</label>
              <input
                type="text"
                className="form-input"
                value={form.referenceNo}
                onChange={(e) => handleChange('referenceNo', e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Required by date:</label>
              <input
                type="date"
                className={`form-input ${errors.requiredByDate ? 'error' : ''}`}
                value={form.requiredByDate}
                onChange={(e) => handleChange('requiredByDate', e.target.value)}
              />
              {errors.requiredByDate && <span className="error-text">{errors.requiredByDate}</span>}
            </div>
          </div>
        </div>

        <hr className="section-divider" />

        {/* Products Section */}
        <div className="form-section-content">
          <div className="form-row">
            <div className="form-group full-width">
              <label>Search Products:</label>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Search Products by name / SKU"
                  value={productSearchTerm}
                  onChange={(e) => setProductSearchTerm(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addProductRow(); } }}
                />
                <button
                  type="button"
                  onClick={addProductRow}
                  style={{ padding: '0 1rem', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: '500' }}
                >Add</button>
              </div>
            </div>
          </div>

          <div className="product-table" style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '600px', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ width: '4%' }}>#</th>
                  <th>Product</th>
                  <th style={{ width: '18%' }}>Alert Quantity</th>
                  <th style={{ width: '18%' }}>Required Quantity</th>
                  <th style={{ width: '4%' }}></th>
                </tr>
              </thead>
              <tbody>
                {form.products.length === 0 ? (
                  <tr><td colSpan={5} className="no-products">No products added</td></tr>
                ) : (
                  form.products.map((p, idx) => (
                    <tr key={p.id}>
                      <td style={{ textAlign: 'center', color: '#64748b', fontSize: '0.8rem' }}>{idx + 1}</td>
                      <td style={{ fontWeight: '500', fontSize: '0.875rem' }}>{p.name}</td>
                      <td>
                        <input
                          type="number"
                          className="form-input"
                          value={p.alertQuantity}
                          min="0"
                          onChange={(e) => updateProduct(p.id, 'alertQuantity', e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </td>
                      <td>
                        <div className="quantity-input-group">
                          <button type="button" className="qty-btn minus" onClick={() => updateProduct(p.id, 'requiredQuantity', Math.max(1, (parseInt(p.requiredQuantity) || 1) - 1))}>-</button>
                          <input type="number" className="quantity-input-centered" value={p.requiredQuantity} min="1" onChange={(e) => updateProduct(p.id, 'requiredQuantity', e.target.value)} />
                          <button type="button" className="qty-btn plus" onClick={() => updateProduct(p.id, 'requiredQuantity', (parseInt(p.requiredQuantity) || 1) + 1)}>+</button>
                        </div>
                      </td>
                      <td><button type="button" className="remove-product-btn" onClick={() => removeProduct(p.id)}>✕</button></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="form-section-content action-buttons-section">
          <div className="action-buttons">
            <button type="submit" className="save-btn">💾 Save</button>
            <button type="button" className="save-print-btn" onClick={handleSave}>🖨️ Save & Print</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddPurchaseRequisition;
